import { ZIPCODE_STATE_MISMATCH } from 'constants/errors';
import { ValidateJSOptions } from 'forms/shared/types';
import { isZipcodeState, zipcodes } from '../../../../../config/zipcodes';
import { LocationModel } from '../../models/location/types';

export type ZipBaseCustomValidator<Model, Key extends keyof Model> = (
  validateModel: any,
  validate: any
) => (
  value: Partial<Model[Key]>,
  options: ValidateJSOptions,
  attributeName: string,
  attributes: Model,
  globalOptions: ValidateJSOptions
) => void

const zipcodeBaseValidator: ZipBaseCustomValidator<LocationModel, 'zipcode'> = (
  validateModel,
  validate
) => (value, options, key, attributes) => {
  const { state } = attributes;

  const validZipcodeState = zipcodes[state as keyof typeof zipcodes] && isZipcodeState(state, value);

  if (validZipcodeState) { return null; }

  return ZIPCODE_STATE_MISMATCH;
};

export default zipcodeBaseValidator;
